import { QRCodeSVG } from "qrcode.react";
import { Printer } from "lucide-react";
import { Tau } from "./common";

export function IdCard({ code, name, line, type }) {
  return (
    <div className="print-card mx-auto w-full max-w-[340px] rounded-2xl border-2 border-[#2D3B2D] bg-white overflow-hidden text-left" data-testid="participant-id-card">
      <div className="bg-[#2D3B2D] text-[#FDFBF7] px-4 py-2.5 flex items-center gap-2">
        <div className="h-7 w-7 rounded-md bg-[#FDFBF7] grid place-items-center"><Tau className="h-4 w-4" /></div>
        <div className="leading-tight">
          <div className="font-serif text-[13px] font-bold">Saint Francis of Assisi Parish</div>
          <div className="text-[9px] uppercase tracking-[0.15em] opacity-80">Brgy. Mabuhay · General Santos City · Diocese of Marbel</div>
        </div>
      </div>
      <div className="p-4 flex gap-4 items-center">
        <QRCodeSVG value={code} size={104} fgColor="#2D3B2D" />
        <div className="min-w-0">
          <div className="text-[9px] uppercase tracking-[0.18em] text-stone-500">Participant ID</div>
          <div className="font-mono text-xl font-black text-[#5C3A21]" data-testid="id-card-code">{code}</div>
          <div className="font-serif font-bold text-[15px] leading-snug mt-1 break-words" data-testid="id-card-name">{name}</div>
          {line && <div className="text-[11px] text-stone-600 mt-0.5 break-words">{line}</div>}
          <div className="text-[9px] uppercase tracking-widest text-[#C85A32] font-bold mt-1">{type === "external" ? "Guest" : "Parishioner"}</div>
        </div>
      </div>
      <div className="px-4 pb-3 text-[9px] text-stone-500">SFAP-AMIS attendance card · Show this QR at the registration desk. Keep your PIN private.</div>
    </div>
  );
}

export function IdCardBlock(props) {
  return (
    <div className="grid gap-3 justify-items-center">
      <IdCard {...props} />
      <button type="button" className="btn-sm btn-ghost no-print" onClick={() => window.print()} data-testid="print-id-card-btn"><Printer className="h-4 w-4" />Print ID card</button>
    </div>
  );
}
